import type { PriceCategoryIdDto, SingleTicketStatusDto } from '@hcr/pwa/api/consumer'

export enum Path {
  About = '/about',
  Account = '/account',
  AccountEdit = '/account/edit',
  Booking = '/booking',
  BookingDetails = '/booking/details',
  ContextMenu = '/context-menu',
  ContextMenuDestinations = '/context-menu/destinations',
  History = '/history',
  HistoryDetailsAccommodation = '/history/accommodations/:accommodationId/details',
  HistoryDetailsTicket = '/history/tickets/:ticketId/details',
  Home = '/',
  Onboarding = '/sign-up',
  OnboardingCompletion = '/sign-up/complete',
  ServiceDetails = '/destinations/:destinationId/services/:serviceId/details',
  Services = '/destinations/:destinationId/services',
  TicketDetailsPackage = '/tickets/packages/:categoryId/details',
  TicketDetailsSingle = '/tickets/singles/:categoryId/details',
}

export const EMPTY_PATH_PARAM = '-' as const

export type PathWithParams =
  | Path.HistoryDetailsAccommodation
  | Path.HistoryDetailsTicket
  | Path.Services
  | Path.ServiceDetails
  | Path.TicketDetailsPackage
  | Path.TicketDetailsSingle
export type PathWithoutParams = Exclude<Path, PathWithParams>

export type EmptyPathParam = typeof EMPTY_PATH_PARAM
export type AccommodationIdPathParam = { accommodationId: string }
export type CategoryIdPathParam = { categoryId: PriceCategoryIdDto }
export type DestinationIdPathParam = { destinationId: string | EmptyPathParam }
export type ServiceIdPathParam = { serviceId: string | EmptyPathParam }
export type TicketIdPathParam = { ticketId: string }

export type HistoryDetailsAccommodationPathParams = AccommodationIdPathParam
export type HistoryDetailsTicketPathParams = TicketIdPathParam

export enum OnboardingCompletionSearchParamsKeys {
  Nonce = 'nonce',
}
export type OnboardingCompletionSearchParams = {
  [OnboardingCompletionSearchParamsKeys.Nonce]: string
}

export type ServicesPathParams = DestinationIdPathParam
export type ServiceDetailsPathParams = DestinationIdPathParam & ServiceIdPathParam

export type TicketDetailsPackagePathParams = CategoryIdPathParam
export enum TicketDetailsPackageSearchParamsKeys {
  AccommodationId = 'accommodationId',
}
export type TicketDetailsPackageSearchParams = {
  [TicketDetailsPackageSearchParamsKeys.AccommodationId]: string
}

export type TicketDetailsSinglePathParams = CategoryIdPathParam
export enum TicketDetailsSingleSearchParamsKeys {
  ResortsIds = 'resortsIds',
  Status = 'status',
}
export type TicketDetailsSingleSearchParams = {
  [TicketDetailsSingleSearchParamsKeys.ResortsIds]: string
  [TicketDetailsSingleSearchParamsKeys.Status]: SingleTicketStatusDto
}
